import React from 'react';
import { Modal, Table, InputNumber } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Employee, EmployeeKpiData } from './types';

interface ViewKpiModalProps {
  isViewKpiModalOpen: boolean;
  handleCloseViewKpiModal: () => void;
  selectedEmployee: Employee | null;
  viewKpiData: EmployeeKpiData[];
  modalLoading: boolean;
}

const ViewKpiModal: React.FC<ViewKpiModalProps> = ({
  isViewKpiModalOpen,
  handleCloseViewKpiModal,
  selectedEmployee,
  viewKpiData,
  modalLoading
}) => {
  const columns: ColumnsType<EmployeeKpiData> = [
    {
      title: 'KRA',
      dataIndex: ['kpiQuestionaire', 'kpiQuestionaire'],
      key: 'kpiQuestionaire',
      width: '25%',
    },
    {
      title: 'KPI (Detailed)',
      dataIndex: ['kpiQuestionaire', 'kpiDescription'],
      key: 'kpiDescription',
      width: '35%',
    },
    {
      title: 'Weightage %',
      dataIndex: ['kpiQuestionaire', 'kpiWeightage'],
      key: 'kpiWeightage',
      align: 'center' as const,
      width: '10%',
    },
    {
      title: 'Target',
      key: 'target',
      width: '15%',
      align: 'center' as const,
      render: (_: unknown, record: EmployeeKpiData) => (
        <InputNumber
          placeholder="Enter Target"
          style={{ width: '100%' }}
          controls={false}
          disabled
          precision={0}
          value={record.totalTargets}
        />
      ),
    },
    {
      title: 'Actual',
      key: 'actual',
      width: '15%',
      align: 'center' as const,
      render: (_: unknown, record: EmployeeKpiData) => {
        const hasTarget = record.totalTargets != null && record.totalTargets !== 0;
        const hasWeightage = record.kpiQuestionaire?.kpiWeightage != null && record.kpiQuestionaire.kpiWeightage !== 0;
        const actual =
          hasTarget && hasWeightage && record.weightScore != null
            ? (record.weightScore / record.kpiQuestionaire.kpiWeightage) * record.totalTargets
            : undefined;

        return (
          <InputNumber
            placeholder="Enter Actual"
            style={{ width: '100%' }}
            controls={false}
            disabled
            precision={0}
            value={actual}
          />
        );
      },
    },
    {
      title: 'Score %',
      key: 'score',
      align: 'center' as const,
      width: '15%',
      render: (_: unknown, record: EmployeeKpiData) => {
        const hasTarget = record.totalTargets != null && record.totalTargets !== 0;
        const hasWeightage = record.kpiQuestionaire?.kpiWeightage != null;
        const score =
          hasTarget && hasWeightage && record.weightScore != null
            ? record.weightScore
            : undefined;

        return (
          <InputNumber
            placeholder="Score"
            style={{ width: '100%' }}
            controls={false}
            disabled
            precision={0}
            value={score}
          />
        );
      },
    }
  ];

  return (
    <Modal
      title={`View KPI for ${selectedEmployee?.firstName || ''} ${selectedEmployee?.lastName || ''}`}
      open={isViewKpiModalOpen}
      onCancel={handleCloseViewKpiModal}
      width={1400}
      className="add-kpi-modal"
      bodyStyle={{ height: 600 }}
      footer={null}
    >
      <Table
        columns={columns}
        dataSource={viewKpiData}
        loading={modalLoading}
        pagination={false}
        rowKey="kpiId"
        scroll={{ y: 500 }}
        bordered
        size="middle"
      />
      <div className="total-weight-container">
        Total: {viewKpiData.reduce((sum, item) => sum + (item.weightScore || 0), 0).toFixed(0)} %
      </div>
    </Modal>
  );
};

export default ViewKpiModal;
